import { JudgeRepository } from '@/domain/repositories/judge/JudgeRepository'
import { ProgramLanguageType } from '@/domain/value_objects/language/programLanguageType'

export class PostTestSubmissionUseCase {
  constructor(private judgeRepository: JudgeRepository) {}

  async postTestSubmission(
    problemId: string,
    programLanguage: ProgramLanguageType,
    sourceCode: string,
    input: string,
    output: string
  ): Promise<string> {
    try {
      const data = await this.judgeRepository.postTestSubmission(problemId, programLanguage, sourceCode, input, output)
      return data
    } catch (error) {
      console.error(`Error in PostTestSubmissionUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }
}
